import FormField from 'app/generic/form/views/FormField';


const INACTIVE_CLASS = 'is-inactive';

class View extends FormField {
	activate() {
		this.$el.removeClass(INACTIVE_CLASS);
	}

	deactivate() {
		this.$el.addClass(INACTIVE_CLASS);
	}
}

export default View;
